var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpSocTelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.897461,
    y: 1.18604,
    width: 47,
    height: 47,
    rx: 11.5,
    fill: "#FFE500",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.897461,
    y: 1.18604,
    width: 47,
    height: 47,
    rx: 11.5,
    stroke: "#FFE500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1925 29.5926L22.1274 31.6016C21.7694 31.9496 21.1704 31.7956 21.0254 31.3176L19.6494 26.7876",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5008 23.6135C26.5008 23.6135 23.9118 25.9495 22.5838 27.1485C22.1868 27.5065 22.2198 28.1365 22.6498 28.4535L28.0278 32.4265C28.5568 32.8175 29.3128 32.5305 29.4498 31.8865L32.0908 19.4395C32.2188 18.8375 31.6278 18.3345 31.0538 18.5555L15.5388 24.5395C15.0818 24.7155 15.1038 25.3685 15.5708 25.5145L19.6478 26.7865",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpSocTelIcon);
export default __webpack_public_path__ + "static/media/lp_soc_tel_icon.355bcc263e28f55a1234aafc705e6baa.svg";
export { ForwardRef as ReactComponent };